<template>
  <smd-one-col-layout content-styles="reset-mp">
    <router-view/>
  </smd-one-col-layout>
</template>

<script>
  export default {
    name: 'appointments-page',
  }
</script>
